export default "__VITE_ASSET__BPDchTu5__"